var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-actions"},[_c('v-select',{staticClass:"license-dropdown",attrs:{"placeholder":_vm.$t('stepper.DD.placeholder'),"value":_vm.shortName},on:{"input":_vm.setCurrentLicense}},_vm._l((_vm.licenseList),function(license){return _c('option',{key:license,domProps:{"value":license}},[_vm._v(" "+_vm._s(license)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }